var _g, _path, _path2, _g2, _path3, _path4, _g3, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 120,
    viewBox: "0 0 212 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_143_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.508 56.612L189.133 110.231C188.774 111.474 187.937 112.524 186.806 113.151C185.674 113.778 184.341 113.931 183.097 113.577L123.691 96.5427C122.447 96.1859 121.395 95.3496 120.768 94.2176C120.14 93.0856 119.988 91.7507 120.345 90.5066L141.569 16.4894C141.926 15.2453 142.762 14.1939 143.894 13.5664C145.026 12.9389 146.361 12.7869 147.605 13.1436L188.555 24.8857C189.016 25.0161 189.44 25.2554 189.79 25.5834C190.085 25.8387 190.325 26.1516 190.494 26.5029L191.602 28.7348L204.316 54.3413L204.359 54.4471C204.495 54.7347 204.578 55.044 204.607 55.3608C204.662 55.7801 204.629 56.2066 204.508 56.612Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.601 55.3801L186.76 50.2643C185.769 49.9799 184.93 49.3132 184.43 48.4108C183.93 47.5085 183.809 46.4444 184.093 45.4527L189.785 25.6027C190.08 25.858 190.319 26.171 190.489 26.5223L191.597 28.7541L204.344 54.4637C204.483 54.7515 204.571 55.0618 204.601 55.3801Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.398 62.7649C179.828 62.5989 179.221 62.606 178.655 62.7852L169.49 65.7228C167.186 66.4605 164.98 67.4769 162.921 68.7495C165.699 71.1873 167.544 74.5147 168.139 78.1623C170.31 77.0874 172.342 75.7521 174.189 74.186L181.537 67.9705C181.949 67.6164 182.259 67.1599 182.437 66.6472C182.614 66.1312 182.647 65.5767 182.532 65.0434C182.417 64.5101 182.159 64.0182 181.786 63.6206C181.411 63.2127 180.931 62.9165 180.398 62.7649ZM161.678 80.4501C162.835 80.1872 163.975 79.8502 165.088 79.441C164.916 77.7158 164.394 76.044 163.553 74.5276C162.713 73.0113 161.572 71.6823 160.2 70.6219C159.263 71.3497 158.373 72.1371 157.537 72.9792L156.896 73.6173C158.089 74.364 159.073 75.4016 159.756 76.6326C160.438 77.8636 160.796 79.2478 160.798 80.6552L161.678 80.4501ZM154.13 74.9567C153.382 74.7421 152.599 74.6772 151.826 74.7657C151.052 74.8541 150.304 75.0941 149.624 75.472C148.943 75.8499 148.344 76.3582 147.861 76.9679C147.377 77.5776 147.018 78.2767 146.805 79.0252C146.714 79.3359 146.56 79.6246 146.353 79.8736C146.147 80.1262 145.889 80.3324 145.597 80.4787C145.31 80.628 144.995 80.7148 144.671 80.7333C144.332 80.7595 143.991 80.708 143.674 80.5826C143.474 80.5127 143.26 80.4978 143.052 80.5394C142.839 80.5785 142.641 80.6768 142.482 80.8232C142.321 80.9675 142.203 81.1532 142.141 81.36C142.08 81.5652 142.075 81.7827 142.126 81.9905C142.567 83.7633 143.581 85.341 145.01 86.4791C146.439 87.6172 148.204 88.252 150.03 88.285C151.857 88.3181 153.644 87.7475 155.113 86.6619C156.582 85.5763 157.652 84.0362 158.157 82.2805C158.369 81.5312 158.434 80.7483 158.35 79.9743C158.165 78.4137 157.375 76.9881 156.15 76.0039C155.551 75.5269 154.865 75.1712 154.13 74.9567Z",
    fill: "#A3A3A3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_143_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9767 36.8875L94.3517 90.5067C94.7085 91.7508 94.5564 93.0857 93.9289 94.2177C93.3014 95.3497 92.25 96.186 91.0059 96.5428L31.5999 113.577C30.3558 113.931 29.0221 113.778 27.8909 113.151C26.7596 112.524 25.9229 111.474 25.5638 110.231L4.33975 36.2142C3.98577 34.9701 4.13905 33.6365 4.76613 32.5052C5.3932 31.3739 6.44299 30.5372 7.6856 30.1781L48.6353 18.436C49.096 18.3019 49.5821 18.2802 50.0528 18.3728C50.4382 18.4331 50.8071 18.5716 51.137 18.7797L53.2591 20.0854L77.6109 35.0633L77.703 35.1305C77.9706 35.3025 78.2056 35.5204 78.3973 35.7741C78.6668 36.1002 78.8642 36.4797 78.9767 36.8875Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4026 35.7934L60.5616 40.9092C59.5698 41.1936 58.5057 41.0724 57.6034 40.5722C56.7011 40.072 56.0344 39.2339 55.75 38.2421L50.0581 18.3921C50.4435 18.4524 50.8124 18.5909 51.1423 18.799L53.2643 20.1047L77.7083 35.1498C77.9758 35.3218 78.2109 35.5397 78.4026 35.7934Z",
    fill: "#E1E1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9844 67.3374C35.3975 67.5043 34.8493 67.7854 34.3712 68.1645C33.8931 68.5435 33.4944 69.0132 33.198 69.5465C32.9016 70.0799 32.7133 70.6665 32.6439 71.2727C32.5745 71.8789 32.6254 72.4928 32.7935 73.0794L37.0632 87.9693C37.2303 88.557 37.5119 89.1059 37.8917 89.5845C38.2716 90.0631 38.7422 90.462 39.2766 90.7582C39.8111 91.0545 40.3987 91.2422 41.0059 91.3107C41.613 91.3793 42.2277 91.3272 42.8147 91.1575L57.7047 86.8879C58.2924 86.7207 58.8413 86.4391 59.3199 86.0593C59.7985 85.6794 60.1974 85.2088 60.4936 84.6744C60.7898 84.14 60.9776 83.5523 61.0461 82.9451C61.1146 82.338 61.0625 81.7233 60.8928 81.1363L56.6232 66.2463C56.455 65.6598 56.1728 65.1122 55.7927 64.6349C55.4126 64.1575 54.9421 63.7599 54.4081 63.4646C53.8741 63.1694 53.2871 62.9824 52.6808 62.9143C52.0744 62.8462 51.4605 62.8983 50.8744 63.0678L35.9844 67.3374ZM67.6788 59.8513C67.616 59.6314 67.505 59.4283 67.3539 59.2567C67.2028 59.085 67.0154 58.9492 66.8052 58.8591C66.5951 58.7689 66.3675 58.7267 66.139 58.7354C65.9105 58.7442 65.6868 58.8037 65.4842 58.9097C65.2111 59.0461 64.9864 59.263 64.8406 59.5312L60.5897 67.2C60.4918 67.377 60.4297 67.5717 60.4071 67.7727C60.3844 67.9738 60.4015 68.1774 60.4576 68.3718L63.021 77.3115C63.0765 77.5061 63.1698 77.6878 63.2956 77.8463C63.4214 78.0048 63.5771 78.137 63.754 78.2352L71.4228 82.4861C71.6901 82.6322 71.9943 82.6969 72.2979 82.6721C72.602 82.6479 72.8916 82.5322 73.1287 82.3403C73.375 82.1545 73.5557 81.895 73.6445 81.5994C73.7386 81.308 73.7431 80.995 73.6573 80.701L67.6788 59.8513Z",
    fill: "#A3A3A3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_143_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.56 29.08V84.86C142.557 86.1535 142.042 87.3932 141.128 88.3078C140.213 89.2224 138.973 89.7374 137.68 89.74H75.88C74.5857 89.74 73.3445 89.2259 72.4293 88.3107C71.5141 87.3955 71 86.1543 71 84.86V7.86001C71 6.56575 71.5141 5.3245 72.4293 4.40933C73.3445 3.49415 74.5857 2.98 75.88 2.98H118.48C118.96 2.97807 119.433 3.09126 119.86 3.31002C120.214 3.4742 120.53 3.70898 120.79 3.99999L122.47 5.84002L141.75 26.95L141.82 27.04C142.03 27.279 142.196 27.5532 142.31 27.85C142.479 28.2378 142.564 28.657 142.56 29.08Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.31 27.87H123.75C122.718 27.87 121.729 27.4601 120.999 26.7306C120.27 26.0011 119.86 25.0116 119.86 23.9799V3.32996C120.214 3.49413 120.53 3.72895 120.79 4.01996L122.47 5.85995L141.82 27.06C142.03 27.299 142.195 27.5732 142.31 27.87Z",
    fill: "#E1E1E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5098 51.3C101.066 51.3 104.76 47.6064 104.76 43.05C104.76 38.4937 101.066 34.8 96.5098 34.8C91.9534 34.8 88.2598 38.4937 88.2598 43.05C88.2598 47.6064 91.9534 51.3 96.5098 51.3Z",
    fill: "#A3A3A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6999 70.96L96.2599 60.96C96.4466 60.7132 96.6841 60.5091 96.9562 60.3616C97.2284 60.2141 97.5289 60.1265 97.8376 60.1047C98.1464 60.0829 98.4563 60.1275 98.7464 60.2353C99.0366 60.3432 99.3003 60.5118 99.5199 60.73L102.88 64.1C103.107 64.3253 103.381 64.4976 103.682 64.6047C103.983 64.7117 104.304 64.7509 104.623 64.7193C104.941 64.6878 105.248 64.5864 105.522 64.4223C105.797 64.2581 106.032 64.0354 106.21 63.77L112.44 54.36C112.648 54.0501 112.933 53.7992 113.267 53.6316C113.601 53.4641 113.973 53.3856 114.346 53.4037C114.719 53.4218 115.081 53.5359 115.397 53.7349C115.713 53.934 115.972 54.2113 116.15 54.54L125.04 71.29C125.214 71.6192 125.3 71.9879 125.29 72.3602C125.279 72.7325 125.173 73.0958 124.981 73.4148C124.788 73.7338 124.517 73.9977 124.193 74.1808C123.868 74.364 123.502 74.4602 123.13 74.46H90.4199C90.0118 74.465 89.6107 74.3542 89.263 74.1405C88.9154 73.9269 88.6353 73.6191 88.4553 73.2529C88.2753 72.8866 88.2028 72.4768 88.2461 72.0711C88.2894 71.6653 88.4467 71.2801 88.6999 70.96Z",
    fill: "#A3A3A3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_143_52",
    x: 116.156,
    y: 10.9546,
    width: 92.4771,
    height: 108.809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_143_52"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_143_52",
    result: "effect2_dropShadow_143_52"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_143_52",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_143_52",
    x: 0.152832,
    y: 16.3164,
    width: 98.3877,
    height: 103.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_143_52"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_143_52",
    result: "effect2_dropShadow_143_52"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_143_52",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_143_52",
    x: 67,
    y: 0.97998,
    width: 79.5601,
    height: 94.76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_143_52"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_143_52",
    result: "effect2_dropShadow_143_52"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_143_52",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcons);
export default __webpack_public_path__ + "static/media/cloud-icons.e9635afaaee306b906ea2f47c34f68df.svg";
export { ForwardRef as ReactComponent };